import { searchPermissions } from '@infuse/api/iam/permission';
import { useGenericPermissions } from './generic/useGenericPermissions';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { searchOrganisationPermissions } from '@infuse/api/iam/organisation';
import { searchTenantPermissions } from '@infuse/api/iam/tenant';
import { UserLevel } from '@infuse/iam/user/type';

export const usePermissions = (forcedLevel?: UserLevel, forcedParentId?: string) => {
  const { level, user } = useCurrentUserStore();

  if ((forcedLevel || level) === UserLevel.TENANT) {
    return useGenericPermissions({
      apiFn: searchTenantPermissions,
      pageSize: 99999,
      queryKeys: ['permissions', 'tenant'],
      initialParentId: forcedParentId || user?.tenantId
    });
  } else if ((forcedLevel || level) === UserLevel.ORGANISATION) {
    return useGenericPermissions({
      apiFn: searchOrganisationPermissions,
      pageSize: 99999,
      queryKeys: ['permissions', 'organisation'],
      initialParentId: forcedParentId || user?.organisationId
    });
  }

  return useGenericPermissions({
    apiFn: searchPermissions,
    pageSize: 99999,
    queryKeys: ['permissions']
  });
};
